import React, { ReactNode } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Caption, CardContent, CollapsibleCard } from '@mesh.ai/rabbit';

import { MeshMavenGreen, MeshMavenOrange } from 'assets/assetsV1/iconComponents';
import noInsights from 'assets/assetsV1/illustrations/deerIllustrations/noInsights.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

const MavenOrangeIcon = () => <MeshMavenOrange boxSize="80px" />;
const MavenGreenIcon = () => <MeshMavenGreen boxSize="80px" />;

interface Props {
  children: ReactNode;
  title?: string;
  subTitle?: string;
  subTitleColor?: 'success' | 'warning';
  rightComp?: ReactNode;
  topSection?: ReactNode;
  showCaption?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => boolean;
  disabled?: boolean;
  isError?: boolean;
  emptyStateDescription?: string;
}

const OverviewSection = ({
  children,
  title,
  subTitle,
  rightComp,
  subTitleColor,
  topSection,
  showCaption,
  open,
  onOpenChange,
  disabled,
  isError,
  emptyStateDescription,
}: Props) => (
  <CollapsibleCard title={title} actions={rightComp} open={open} disabled={disabled} onOpenChange={onOpenChange}>
    {isError ? (
      <Box width="100%">
        <CardContent>
          <EmptyScreen
            illustrationSrc={noInsights}
            heading="Not enough data to show"
            isSmallTextSize
            description={emptyStateDescription}
          />
        </CardContent>
      </Box>
    ) : (
      <Box width="100%">
        <Flex flexDirection="column" width="100%" marginBottom="8px" marginTop="4px">
          {showCaption && subTitle?.length > 0 && (
            <Caption
              style={{
                fontSize: '14px',
                lineHeight: '1.5',
                marginTop: '8px',
              }}
              color={subTitleColor}
              icon={subTitleColor === 'success' ? MavenGreenIcon : MavenOrangeIcon}
            >
              {subTitle}
            </Caption>
          )}
        </Flex>
        <CardContent>
          {topSection && (
            <Box borderRadius="8px" bg="#F5F7F9" p={2} mb={2}>
              {topSection}
            </Box>
          )}
          <Box borderRadius="8px" bg="#F5F7F9" p={2}>
            {children}
          </Box>
        </CardContent>
      </Box>
    )}
  </CollapsibleCard>
);

export default OverviewSection;
